import { Link } from "@tanstack/react-router";
import { useTranslation } from "../../i18n";
import { ModelIcon } from "../../model-icon";

// Homepage editorial display; model details retain their live catalog data.
const featuredModels = [
  { slug: "bytedance/doubao-seedance-2-5-260628", displayName: "Doubao Seedance 2.5" },
  { slug: "google/veo-3.1-generate-001", displayName: "Veo 3.1" },
  { slug: "alibaba/wan3.0-video", displayName: "Wan 3.0 Video" },
  { slug: "vidu/baidu-vod-vq3p", displayName: "Vidu Q3 Pro" },
  { slug: "openai/gpt-image-2.5-flare", displayName: "GPT Image 2.5 Flare" },
  { slug: "bytedance/doubao-seedream-5-0-pro-260628", displayName: "Doubao Seedream 5.0 Pro" },
  { slug: "google/gemini-3.1-flash-image", displayName: "Gemini 3.1 Flash Image" },
  { slug: "runninghub/runninghub-youchuan-text-to-image-v81", displayName: "Midjourney V8.1" },
  { slug: "anthropic/claude-opus-5-5", displayName: "Claude Opus 5.5" },
  { slug: "openai/gpt-6-astra", displayName: "GPT-6 Astra" },
  { slug: "google/gemini-3-8-flash", displayName: "Gemini 3.8 Flash" },
  { slug: "minimax/MiniMax-H3", displayName: "MiniMax H3" },
  { slug: "elevenlabs/eleven_v3", displayName: "Eleven v3" },
  { slug: "minimax/music-2.6", displayName: "MiniMax Music 2.6" },
  { slug: "fish-audio/s2-pro", displayName: "Fish Audio S2 Pro" },
  { slug: "bytedance/doubao-tts-v2", displayName: "Doubao TTS v2" },
] as const;

export function HomeModelShowcase() {
  const { t } = useTranslation();
  return <section className={`home-section home-model-showcase
  pt-25 [scroll-margin-top:calc(var(--site-navigation-height,79px)_+_24px)]
  maxw-[760px]:pt-18
  pb-12
`} id="home-model-showcase" aria-labelledby="home-model-showcase-heading">
    <div className={`home-model-showcase-copy
  [container-type:inline-size] [margin:0_auto_56px] text-center
  maxw-[700px]:mb-7
`}><h2 id="home-model-showcase-heading">{t("creativeHome.galleries.modelsTitle")}</h2>
      <p>{t("creativeHome.galleries.modelsDescription")}</p></div>
    <div className={`home-brand-grid
  grid [grid-template-columns:repeat(4,minmax(0,1fr))] [gap:24px_40px]
  [&>a]:flex [&>a]:items-center [&>a]:gap-4 [&>a]:min-w-0 [&>a]:min-h-25 [&>a]:[padding:12px_0] [&>a]:text-foreground [&>a]:no-underline [&>a]:[border-radius:8px] [&>a]:outline-offset-1.5
  [&>a>span:last-child]:[font-size:clamp(17px,1.6vw,24px)] [&>a>span:last-child]:[line-height:1.35] [&>a>span:last-child]:[overflow-wrap:anywhere]
  [&>a:hover]:text-accent-foreground
  [&>a:focus-visible]:[outline:2px_solid_var(--ring)]
  maxw-[960px]:[gap:16px_24px] maxw-[960px]:[grid-template-columns:repeat(3,minmax(0,1fr))]
  maxw-[700px]:[grid-template-columns:repeat(2,minmax(0,1fr))] maxw-[700px]:[gap:16px_20px]
  maxw-[700px]:[&>a]:gap-3 maxw-[700px]:[&>a]:min-h-22
  maxw-[700px]:[&>a>span:last-child]:[font-size:16px]
`}>{featuredModels.map(model => <Link to="/models/$" params={{ _splat: model.slug }} key={model.slug}>
      <ModelIcon source={[model.slug, model.displayName]} size="xl" className="size-12 rounded-none bg-transparent ring-0 grayscale" />
      <span>{model.displayName}</span>
    </Link>)}</div>
  </section>;
}
